module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/files/pictures-2-42f1c7dfa3fba0dd94355c3ac43faae4.svg";